import { IAutoCompleteService } from '../component/autocomplete-remote/autocomplete-remote.component';
import { SelectionItem } from '../component/select/select.component';
import { FilterType } from './const/enums';
import { LocalDate } from './local-date';
import { FilterItem } from './selectable-items';

export class FilterDefinitionItem<TSelector = any, TData = any, TOptions = any> implements FilterItem {
  public readonly autoCompleteService?: IAutoCompleteService<TData, TOptions>;
  public itemsSource?: SelectionItem<TData>[];
  mandatory?: boolean;
  placeholderText?: string;

  constructor(
    public readonly caption: string,
    public readonly name: string,
    public readonly value: TSelector,
    itemsSource?:
      | { caption: string; value: TData | ''; disabled?: boolean; filterData?: { [key: string]: any }; icon?: string }[]
      | IAutoCompleteService<TData, TOptions>,
    public selected: boolean = true,
    public allowMultipleSelection: boolean = false,
    public serviceOptions?: TOptions,
    public readonly updateOnOptionsChange?: boolean,
    public readonly defaultSearch?: string
  ) {
    if (itemsSource && Array.isArray(itemsSource)) {
      this.itemsSource = itemsSource ? itemsSource.map(x => new SelectionItem(x.caption, x.value, x.disabled, x.filterData, x.icon)) : null;
    } else {
      this.autoCompleteService = itemsSource as IAutoCompleteService;
    }
  }

  get filterType(): FilterType {
    if (this.itemsSource?.length) {
      return FilterType.Selection;
    }
    if (this.autoCompleteService) {
      return this.allowMultipleSelection ? FilterType.AutoCompleteMulti : FilterType.AutoComplete;
    }
    if (this.value instanceof LocalDate) {
      return FilterType.LocalDate;
    }
    return FilterType.Textbox;
  }
}

export class FilterDefinitionItemDateTime extends FilterDefinitionItem {
  constructor(caption: string, name: string, value: Date, selected: boolean) {
    super(caption, name, value, undefined, selected, false);
  }

  get filterType(): FilterType {
    return FilterType.DateTime;
  }
}

export class FilterDefinitionItemLocalDate extends FilterDefinitionItem {
  constructor(caption: string, name: string, value: LocalDate, selected: boolean) {
    super(caption, name, value ? LocalDate.fromDate(value) : null, undefined, selected, false);
  }

  get filterType(): FilterType {
    return FilterType.LocalDate;
  }
}
